@if (params.data.templateApplicationMasterId) {
    <button type="button" (click)="navigate()" class="text-primary-800">
        Edit
    </button>
}
